import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TriangleDown as TriangleDownIcon } from "@air/next-icons";
import classNames from "classnames";
import { memo } from "react";
export const TreeHeader = /*#__PURE__*/ memo((param)=>{
    let { adornmentLeft, adornmentRight, className, isExpanded = false, onTitleClick, showAdornmentLeft, showAdornmentRight, title, ...restOfProps } = param;
    return /*#__PURE__*/ _jsxs("header", {
        className: classNames("group flex h-9 items-center gap-2", className),
        "data-testid": "TREE_HEADER-".concat(title),
        ...restOfProps,
        children: [
            adornmentLeft && /*#__PURE__*/ _jsx("div", {
                className: classNames("flex shrink-0 gap-1", showAdornmentLeft ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"),
                children: adornmentLeft
            }),
            title && /*#__PURE__*/ _jsxs("button", {
                className: "mr-auto flex h-6 select-none items-center gap-1 rounded-4 border-0 bg-transparent px-2 text-12 font-semibold text-grey-9 transition-colors hover:bg-grey-4",
                onClick: onTitleClick,
                children: [
                    title,
                    /*#__PURE__*/ _jsx(TriangleDownIcon, {
                        className: classNames("block h-4 w-4 transition-transform", isExpanded ? "rotate-0" : "-rotate-90")
                    })
                ]
            }),
            adornmentRight && /*#__PURE__*/ _jsx("div", {
                className: classNames("flex shrink-0 gap-1", showAdornmentRight ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"),
                children: adornmentRight
            })
        ]
    });
});
TreeHeader.displayName = "TreeHeader";
